import { TInfrastructureState } from '../../types/map';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EInfrastructureActionTypes {
  SetInfrastructure = 'infrastructure/set',
}

export type TSetInfrastructureActionPayload = TInfrastructureState;

export type TSetInfrastructureAction = ITypedReduxAction<
  EInfrastructureActionTypes.SetInfrastructure,
  TSetInfrastructureActionPayload
>;

/**
 * Redux action, который записывает в store инфраструктуру.
 */
export const setInfrastructureAction: (payload: TSetInfrastructureActionPayload) => TSetInfrastructureAction =
  actionGenerator<EInfrastructureActionTypes.SetInfrastructure, TSetInfrastructureActionPayload>(
    EInfrastructureActionTypes.SetInfrastructure,
  );
